export default function (text: string) {
  const regexHtmlTags = /(<([^>]+)>)/ig
  const regexDuplicateSpaces = /\s\s+/g
  return text.replace(regexHtmlTags, ' ').replace(regexDuplicateSpaces, ' ').trim()
}
